import {useAppDispatch, useAppSelector} from "../../redux/store";
import {InputContainer, LoginContainer} from "./styled";
import BarekamButton, {
    AuthButtons,
    SimpleButtons,
} from "../components/button";
import "react-phone-input-2/lib/material.css";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {recoverPassword} from "../../redux/slices/register-slice";
import BarekamText from "../components/text";
import BarekamInput from "../components/input";
import "react-toastify/dist/ReactToastify.css";
import {MessageSections} from "../components/message/message";
import {PayloadAction} from "@reduxjs/toolkit";
import {Footer} from "../footer/footer";
import Message from "../components/message";
import {getMessage} from "../shared/helper-functions";

const Recover = () => {
    const {messageCache, languageId} = useAppSelector(
        (state) => state.messagesReducer,
    );

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [email, setEmail] = useState<string>();
    const [emailError, setEmailError] = useState<string>("");

    function recover(): void {
        if (passedValidations()) {
            dispatch(recoverPassword({email, languageId})).then(
                (data: PayloadAction<any>) => {
                    if (data.payload.error) {
                        const message = data.payload.error.response.data.key;
                        setEmailError(message);
                    } else {
                        const options = {
                            toastMessage: getMessage(
                                "recovery_confirmation_info",
                                MessageSections.LOGIN,
                                messageCache,
                                languageId,
                            ),
                            toastType: "info",
                        };
                        navigate("../login", {state: options});
                    }
                },
            );
        } else {
            setEmailError("field_is_required");
        }
    }

    function passedValidations() {
        return !!email;
    }

    return (
        <>
            <LoginContainer>
                <InputContainer>
                    <BarekamText variant={"l"} align={"center"} bold>
                        <Message
                            messageKey={"forgot_password"}
                            sectionId={MessageSections.LOGIN}
                        />
                    </BarekamText>

                    <BarekamText variant={"m"} align={"center"} opaque>
                        <Message
                            messageKey={"forgot_password_description"}
                            sectionId={MessageSections.LOGIN}
                        />
                    </BarekamText>
                    <BarekamInput
                        key={"register-email"}
                        customInputVariant={"standard"}
                        placeholder={getMessage(
                            "email",
                            MessageSections.LOGIN,
                            messageCache,
                            languageId,
                        )}
                        value={email}
                        onKeyUp={(event) => event.key === "Enter" && recover()}
                        onChange={(value) => setEmail(value.target.value)}
                        type={"email"}
                        error={!!emailError}
                        errorMessage={
                            emailError &&
                            getMessage(
                                emailError,
                                MessageSections.LOGIN,
                                messageCache,
                                languageId,
                            )
                        }
                        width={"100%"}
                        required
                        validatePattern
                    />

                    <BarekamButton type={AuthButtons.MAIN} size={"l"} onClick={recover}>
                        <BarekamText variant={"l"} fontWeight={700} align={"center"}>
                            <Message
                                messageKey={"request_reset_link"}
                                sectionId={MessageSections.LOGIN}
                            />
                        </BarekamText>
                    </BarekamButton>

                    <div style={{display: "flex", justifyContent: "center"}}>
                        <BarekamButton
                            type={SimpleButtons.LINK}
                            onClick={() => navigate("../login")}
                        >
                            <BarekamText variant={"m"}>
                                <Message
                                    messageKey={"back_to_sign_in"}
                                    sectionId={MessageSections.LOGIN}
                                />
                            </BarekamText>
                        </BarekamButton>
                    </div>
                </InputContainer>
            </LoginContainer>

            <Footer/>
        </>
    );
};

export default Recover;
